import { useParams } from "react-router-dom";
import UnifiedLogin from "../UnifiedLogin";

/** School-branded entry to the unified login (staff + student tabs). */
const SchoolLoginPage = ({ schoolSlugFromHost }) => {
    const { slug } = useParams();
    return <UnifiedLogin schoolId={schoolSlugFromHost || slug} />;
};

export default SchoolLoginPage;
